

export const SoftwareAuth = () => {

  return (
    <>
      <div className="content px-4 mx-auto">
        <div className="text-lg md:text-2xl font-medium text-Headline mt-6 md:mt-12 mb-6 md:mb-8">各校授權軟體</div>

        <div className="relative shadow-md sm:rounded-lg">
          <table className="ctable w-full text-sm text-left rtl:text-right text-gray-500">
            <thead className="hidden md:table-header-group text-xs text-gray-700 uppercase bg-[#effaf9]">
              <tr>
                <th className="min-w-36">軟體名稱</th>
                <th>授權時間</th>
              </tr>
            </thead>
            <tbody>
              <tr className="flex md:table-row flex-col border-b py-4 md:py-2">
                <th>PaGamO素養學習-中文素養題組帳號授權</th>
                <td>自2024-09-11至2024-09-18</td>
              </tr>
              <tr className="flex md:table-row flex-col border-b py-4 md:py-2">
                <th>HyRead行動學習電子雜誌庫</th>
                <td>無限制</td>
              </tr>
            </tbody>
          </table>
        </div>

      </div>

    </>
  )
}